import React from "react";
import { DesktopSidebar } from "./vc/DesktopSidebar";

/**
 * Responsive app shell.
 *  - Mobile (default): centered phone-frame column with subtle shadow.
 *  - Desktop (lg+): fixed left sidebar + wider content area (max-w-4xl).
 *
 * The DesktopSidebar itself is hidden below `lg:` via internal Tailwind classes,
 * so it's safe to render unconditionally.
 */
export const MobileShell = ({ children, showSidebar = true }) => (
  <div className="min-h-screen bg-slate-100 flex justify-center">
    {showSidebar && <DesktopSidebar />}
    <div className={`mobile-shell w-full max-w-md min-h-screen relative bg-slate-50 shadow-2xl shadow-slate-300/50 lg:shadow-none ${showSidebar ? "lg:max-w-4xl lg:ml-56" : ""}`}>
      {children}
    </div>
  </div>
);
